import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { effects } from './effects/index';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature(effects), RouterModule],
})
export class UserStoreModule {}
